"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment_1 = require("moment");
function carolCampaign(state) {
    return state.carolCampaign;
}
exports.carolCampaign = carolCampaign;
function durations(state) {
    return lodash_1.sortBy(state.availableDurations, 'id');
}
exports.durations = durations;
function filteredRoutes(state) {
    var filteredResults = state.searchResults;
    if (state.filter.depGermany) {
        filteredResults = lodash_1.filter(filteredResults, function (route) {
            return (lodash_1.indexOf(['Hamburg', 'Kiel', 'Warnemünde', 'Bremerhaven'], route.startHabour) !== -1);
        });
    }
    if (state.filter.travelDuration !== 9999) {
        var duration_1 = selectedTravelDuration(state);
        filteredResults = lodash_1.filter(filteredResults, function (route) {
            var durationFrom = duration_1.from ? duration_1.from : 9999;
            var durationTo = duration_1.to ? duration_1.to : -1;
            var routeFromOk = route.duration >= durationFrom;
            var routeToOk = route.duration <= durationTo;
            return routeFromOk && routeToOk;
        });
    }
    return filteredResults;
}
exports.filteredRoutes = filteredRoutes;
function filters(state) {
    return state.filter;
}
exports.filters = filters;
function lastMinuteOffers(state) {
    var viewOffers = getLmoData(lodash_1.cloneDeep(filteredRoutes(state)));
    return viewOffers;
}
exports.lastMinuteOffers = lastMinuteOffers;
function lowestPrice(state) {
    var lmos = getLmoData(state.searchResults);
    lmos = sortOffers('price', lmos);
    return lmos.length > 0 ? lmos[0].price : 0;
}
exports.lowestPrice = lowestPrice;
function lowestPriceSO(state) {
    return function (code) {
        var cheap = specialOffersCheapestPriceByCampaignName(state)(code);
        return cheap;
    };
}
exports.lowestPriceSO = lowestPriceSO;
function numberCruises(state) {
    return offers(state).length;
}
exports.numberCruises = numberCruises;
function numberSpecialCruises(state) {
    return function (code, virtualRegionName) {
        return specialOffers(state)(code, virtualRegionName).length;
    };
}
exports.numberSpecialCruises = numberSpecialCruises;
function offers(state) {
    var lmos = lodash_1.cloneDeep(lastMinuteOffers(state));
    lmos = sortOffers(state.sortBy.code, lmos);
    return lmos;
}
exports.offers = offers;
function regions(state) {
    var regionsFilter = [
        {
            id: 'NONE',
            name: 'Alle Regionen',
            shortName: 'Alle',
        },
    ];
    return lodash_1.concat(regionsFilter, lodash_1.sortBy(state.availableRegions, 'name'));
}
exports.regions = regions;
function selectedRegion(state) {
    var regionsArray = regions(state);
    var region = lodash_1.find(regionsArray, {
        id: state.filter.region,
    });
    if (region) {
        return region;
    }
    return {
        id: 'NONE',
        name: 'Region',
        shortName: 'Region',
    };
}
exports.selectedRegion = selectedRegion;
function selectedTravelDuration(state) {
    var durationsArray = durations(state);
    var duration = lodash_1.find(durationsArray, {
        id: state.filter.travelDuration,
    });
    if (duration) {
        return duration;
    }
    return {
        from: undefined,
        id: 9999,
        name: 'Reisedauer',
        shortName: 'Dauer',
        to: undefined,
    };
}
exports.selectedTravelDuration = selectedTravelDuration;
function sortOptions(state) {
    return state.sortBy;
}
exports.sortOptions = sortOptions;
function specialCampaigns(state) {
    return state.carolCampaign.specialOffers;
}
exports.specialCampaigns = specialCampaigns;
function specialHeaderImage(state) {
    return function (code) {
        var offer = lodash_1.find(state.carolCampaign.specialOffers, { name: code });
        return offer ? offer.headerImage : undefined;
    };
}
exports.specialHeaderImage = specialHeaderImage;
function specialOffers(state) {
    return function (code, virtualRegionName) {
        var specialResults = lodash_1.find(state.specialResults, ['code', code]);
        if (!specialResults) {
            return [];
        }
        var filterRegions = [];
        if (virtualRegionName) {
            var campaign = lodash_1.find(state.carolCampaign.specialOffers, { name: code });
            if (campaign) {
                var virtualRegion = lodash_1.find(campaign.virtualRegions, {
                    name: virtualRegionName,
                });
                if (virtualRegion) {
                    lodash_1.each(virtualRegion.regions, function (region) {
                        if (region.id === 'all') {
                            filterRegions.length = 0;
                            return false;
                        }
                        filterRegions.push(region.id);
                    });
                }
            }
        }
        var filteredOffers = getSpecialData(lodash_1.filter(specialResults.offers, function (offer) {
            var offerAvailable = lodash_1.find(offer.cabinCategories, ['available', true]);
            if (!offerAvailable) {
                return false;
            }
            if (!filterRegions.length) {
                return true;
            }
            if (!offer.journeys) {
                return false;
            }
            return offer.journeys.length > 0 && offer.journeys[0].regionID
                ? filterRegions.indexOf(offer.journeys[0].regionID) > -1
                : false;
        }));
        return sortOffers(state.specialSortBy.code, filteredOffers);
    };
}
exports.specialOffers = specialOffers;
function specialOffersCheapestPriceGroupedByVirtualRegion(state) {
    return function (code) {
        var groupedPrices = {};
        var campaign = lodash_1.find(state.carolCampaign.specialOffers, function (specialOffer) {
            return specialOffer.name === code;
        });
        if (campaign) {
            lodash_1.each(campaign.virtualRegions, function (virtualRegion) {
                groupedPrices[virtualRegion.name] = null;
                var specOffers = specialOffers(state)(code, virtualRegion.name);
                lodash_1.each(specOffers, function (offer) {
                    if (groupedPrices[virtualRegion.name] === null ||
                        groupedPrices[virtualRegion.name] > offer.price) {
                        groupedPrices[virtualRegion.name] = offer.price;
                    }
                });
            });
        }
        return groupedPrices;
    };
}
exports.specialOffersCheapestPriceGroupedByVirtualRegion = specialOffersCheapestPriceGroupedByVirtualRegion;
function specialOffersCheapestPriceByCampaignName(state) {
    return function (code) {
        var cheapestPrice = 0;
        var campaign = lodash_1.find(state.carolCampaign.specialOffers, function (specialOffer) {
            return specialOffer.name === code;
        });
        if (campaign) {
            if (campaign.virtualRegions.length === 0) {
                var specOffers = specialOffers(state)(code);
                lodash_1.each(specOffers, function (offer) {
                    if (cheapestPrice === 0 || cheapestPrice > offer.price) {
                        cheapestPrice = offer.price;
                    }
                });
            }
            else {
                lodash_1.each(campaign.virtualRegions, function (virtualRegion) {
                    var specOffers = specialOffers(state)(code, virtualRegion.name);
                    lodash_1.each(specOffers, function (offer) {
                        if (cheapestPrice === 0 || cheapestPrice > offer.price) {
                            cheapestPrice = offer.price;
                        }
                    });
                });
            }
        }
        return cheapestPrice;
    };
}
function specialTeaserImage(state) {
    return function (code) {
        var offer = lodash_1.find(state.carolCampaign.specialOffers, { name: code });
        return offer ? offer.teaserImage : undefined;
    };
}
exports.specialTeaserImage = specialTeaserImage;
function specialSortOptions(state) {
    return state.specialSortBy;
}
exports.specialSortOptions = specialSortOptions;
function stateAll(state) {
    return state;
}
exports.stateAll = stateAll;
function getLmoData(routes) {
    var results = [];
    lodash_1.each(routes, function (route) {
        var mapped = lodash_1.map(route.cruises, function (cruise) {
            var pauschal = cruise.priceModel === 'PAUSCHAL';
            return {
                amenity: pauschal ? cruise.priceInfo.surcharges : null,
                cruiseId: cruise.cruiseID,
                cruiseName: route.name,
                datesDisplay: cruise.datesDisplay,
                duration: route.duration,
                flight: cruise.flight,
                germanArrival: lodash_1.indexOf(['Kiel', 'Hamburg', 'Warnemünde', 'Bremerhaven'], route.endHabour) > -1
                    ? true
                    : false,
                germanDeparture: lodash_1.indexOf(['Kiel', 'Hamburg', 'Warnemünde', 'Bremerhaven'], route.startHabour) > -1
                    ? true
                    : false,
                price: cruise.price / 2,
                priceModel: cruise.priceModel,
                ship: cruise.ship,
                start: cruise.start,
                startPort: route.startHabour,
            };
        });
        results = lodash_1.concat(results, mapped);
        return mapped;
    });
    return results;
}
function getSpecialData(aprilOffers) {
    var mapped = lodash_1.map(aprilOffers, function (offer) {
        var pauschal = offer.priceModel === 'PAUSCHAL';
        var endPort = endHarbourName(offer);
        var startPort = startHarbourName(offer);
        var defaultAmenity = {
            amount: 0,
            description: '',
            id: '',
            type: '',
        };
        var amenities = 'cabinCategories[0].amenities[0]';
        var amenity = lodash_1.get(offer, amenities, defaultAmenity);
        return {
            amenity: pauschal ? amenity : defaultAmenity,
            cruiseId: offer.cruiseID,
            cruiseName: lodash_1.get(offer, 'itinerary[0].name', ''),
            datesDisplay: offer.startDate + ' bis ' + offer.endDate,
            duration: offer.duration,
            flight: offer.mandatoryFlight ? offer.flight : {},
            germanArrival: germanPort(endPort),
            germanDeparture: germanPort(startPort),
            price: offer.price ? offer.price / 2 : 0,
            priceModel: offer.priceModel,
            ship: lodash_1.get(offer, 'ships[0].name', 'AIDA'),
            start: offer.startDate,
            startPort: startPort,
        };
    });
    return mapped;
}
function germanPort(port) {
    var germanPorts = ['Kiel', 'Hamburg', 'Warnemünde', 'Bremerhaven'];
    return lodash_1.indexOf(germanPorts, port) > -1;
}
function endHarbourName(offer) {
    var journeys = offer.journeys;
    var journeyOk = journeys && journeys.length > 0;
    if (!journeyOk) {
        return '';
    }
    var lastSegment = journeyOk ? lodash_1.last(journeys[0].segments) : undefined;
    var endHarbourId = lastSegment ? lastSegment.portID : '';
    var endHarbour = lodash_1.find(offer.ports, ['id', endHarbourId]);
    return endHarbour ? endHarbour.name : '';
}
function startHarbourName(offer) {
    var journeys = offer.journeys;
    var journeyOk = journeys && journeys.length > 0;
    if (!journeyOk) {
        return '';
    }
    var segments = journeyOk ? offer.journeys[0].segments : undefined;
    var segmentsOk = segments && segments.length > 0;
    var startHarbourId = segments && segmentsOk ? segments[0].portID : '';
    var startHarbour = lodash_1.find(offer.ports, ['id', startHarbourId]);
    return startHarbour ? startHarbour.name : '';
}
function sortOffers(code, lmOffers) {
    var offersSorted;
    switch (code) {
        case 'date':
            offersSorted = lodash_1.sortBy(lmOffers, function (offer) {
                return moment_1.utc(offer.start, 'DD.MM.YYYY');
            });
            break;
        case 'price':
        default:
            offersSorted = lodash_1.sortBy(lmOffers, function (offer) {
                return offer.price;
            });
    }
    return offersSorted;
}
//# sourceMappingURL=getters.js.map